module.exports = __webpack_public_path__ + "static/media/daytime.c245a69a.svg";